import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const dinnerApi = {
    getList(current, size = 10) {
        return httpClient.get(API_ROUTES.dinner_list, {
            params: { current, size },
        })
    },

    getByGame(gameId) {
        return httpClient.get(API_ROUTES.dinner_info, {
            params: { gameId },
        })
    },

    getDetail(dinnerId) {
        return httpClient.get(API_ROUTES.dinner_detail, {
            params: { dinnerId },
        })
    },

    create(payload) {
        return httpClient.post(API_ROUTES.dinner_create, payload)
    },

    update(payload) {
        return httpClient.post(API_ROUTES.dinner_update, payload)
    },

    join(formData) {
        return httpClient.post(API_ROUTES.dinner_join, formData)
    },

    joinById(formData) {
        return httpClient.post(API_ROUTES.dinner_join_by_id, formData)
    },
}
